module.exports = {
  language: {
    name: '简体中文',
    title: '选择语言',
    subList: [
      {
        name: 'English',
        link: 'en',
      },
      // {
      //   name: '简体中文',
      //   link: 'zh',
      // },
      {
          name: '繁體中文',
          link: 'tw',
      },
      {
        name: '日本語',
        link: 'jp',
      },
      {
        name: '한국어',
        link: 'kr',
      },
      {
        name: 'ไทย',
        link: 'th',
      },
      {
        name: 'Tiếng Việt',
        link: 'vn',
      },
      {
        name: 'Español',
        link: 'es',
      },
    ]
  },
  "user":{//của tôi
    "wdtd": "Nhóm của tôi",
    "wdyj": "Hiệu suất của tôi",
    "ren": "người",
  },
  "kjsy": {
    "title": "Doanh thu",
    "fxsy": "Chia sẻ doanh thu",
    "zjlsl": "Tổng số tiền thưởng:",
    "jl": "Phần thưởng",
    "sj": "ngày",
    "sl": "Số lượng",
    "sm": "Mô tả"
  },
  "pay":{//mua hàng
    "title": 'Mua máy khai thác',
    "gmsl": 'Số lượng mua',
    "zf": 'Thanh toán',
    "kyye": 'Số dư khả dụng',
    "kyyebz": 'Không đủ số dư khả dụng',
    "bztbtips": 'Số tiền rút đầu vào nhỏ hơn yêu cầu rút tiền tối thiểu của loại tiền tệ',
    "bztbtips2": 'Số tiền rút không được thấp hơn số tiền rút tối thiểu',
    "qsrjymm": 'Vui lòng nhập mật khẩu giao dịch gồm 6 chữ số',
    "wxts": 'Lời nhắc',
  },
  "chongbi": {
    "title": 'Tiền gửi',
    "lianmc": 'Loại chuỗi',
    "scl": 'Tạo chuỗi độc quyền',
    "sy": 'khóa riêng',
    "ewm": 'mã QR',
    "bcewm": 'Lưu mã QR',
    "cbdz": 'Địa chỉ tiền gửi',
    "fz": 'Sao chép',
    "sl": 'Số tiền gửi',
    "qsrsl": 'Vui lòng nhập số tiền gửi',
    "sjczje": 'Số tiền nạp thực tế',
    "qsrsjczje": 'Vui lòng nhập số tiền nạp thực tế',
    "pzms": 'Mô tả chứng chỉ',
    "qsrms": 'Vui lòng nhập mô tả',
    "hxz": 'giá trị băm',
    "qsrhxz": 'Vui lòng nhập giá trị băm',
    "pztp": 'Hình ảnh phiếu thưởng',
    "qscpztp": 'Vui lòng tải ảnh chứng chỉ lên',
    "fzcg": 'Sao chép thành công',
    "yhkcz": 'Nạp tiền vào thẻ ngân hàng',
    "usdtcz": 'Nạp USDT',
    "btccz": 'Nạp BTC',
    "xzbz": 'Chọn tiền tệ',
    "chắc chắn": 'Xác nhận',
    "ck": 'Xem',
    "tips1": "Vui lòng không nạp bất kỳ tài sản nào không phải bằng đơn vị tiền tệ này vào địa chỉ trên nếu không sẽ không thể truy xuất tài sản",
    "tips2": "1. Khả năng tương thích của ví / nền tảng: nghĩa là mạng được hỗ trợ; nếu nền tảng đích không hỗ trợ mạng rút tiền của bạn, thì không thể truy xuất tài sản.",
    "tips3": "2. Mạng nạp tiền của bạn và nền tảng mục tiêu giống nhau; nếu bạn chọn địa chỉ mục tiêu là mạng Ethereum, nhưng người nạp tiền chọn chuỗi thông minh TRC20, bạn có thể không truy xuất được tài sản kỹ thuật số của mình.",
    "tips4": "3. Đảm bảo rằng địa chỉ và số tiền của bạn là chính xác trước khi nạp tiền.",
    "tips5": "Nhắc nhở: Do tính ẩn danh và tính riêng tư của mạng khối, một khi bạn nhập sai thông tin, bạn sẽ mất tài sản tương ứng. Vui lòng kiểm tra kỹ địa chỉ và số lượng nạp tiền của bạn"
  },
  "usdttb":{
    "title": 'Rút xu',
    "lmc": 'Loại chuỗi',
    "xzl": 'Chọn chuỗi',
    "xztbdz": 'Chọn địa chỉ rút tiền',
    "qsrtbdz": 'Vui lòng nhập địa chỉ rút tiền',
    "tbdz": 'Địa chỉ rút tiền',
    "qsrdz": 'Vui lòng nhập địa chỉ',
    "tbsl": 'Số tiền rút',
    "tbsl2": 'Số tiền rút:',
    "qsrtbsl": 'Vui lòng nhập số tiền rút',
    "sjtxje": 'Số tiền rút thực tế',
    "qsrsjtxje": 'Vui lòng nhập số tiền rút thực tế',
    "dzje":'Số tiền nhận được',
    "jymm": 'Mật khẩu giao dịch',
    "qsrjymm": 'Vui lòng nhập mật khẩu giao dịch',
    "sxf": 'phí xử lý',
    "qsrsxf": 'Vui lòng nhập phí xử lý',
    "dzsl": 'Số tiền tài khoản',
    "dzsl2": 'Số tiền tài khoản nhận được:',
    "qsrdzsl": 'Vui lòng nhập số tiền tài khoản',
    "wxts": 'Lời nhắc:',
    "mrzdtxcs": 'Số tiền rút tối thiểu mỗi lần:',
    "hxxf": 'Cần tiêu dùng',
    "cktx": 'Chỉ có thể rút tiền',
    "ci": 'lần',
    "wddtxyq": 'Yêu cầu rút tiền không được đáp ứng',
    "tjcg": 'Gửi thành công, vui lòng đợi đánh giá',
    "tips": 'Bạn chỉ có thể rút tiền nếu sức mạnh tính toán của chính bạn lớn hơn 1T (ngoại trừ sức mạnh tính toán của máy khai thác kinh nghiệm) hoặc sức mạnh tính toán dưới chiếc ô lớn hơn 50T. ',
    "dz": 'địa chỉ',
    "qd": 'Được',
    "zdtb": "Số tiền rút tối thiểu"
  },
  "kefu": {
    "title":'Liên hệ với dịch vụ khách hàng',
    "zxkf":'Liên hệ dịch vụ khách hàng',
    "fzcg":'Sao chép thành công'
  },
  "xgdlmm":{//Sửa đổi mật khẩu đăng nhập
    "title":'Thay đổi mật khẩu đăng nhập',
    "t1":'Mật khẩu đăng nhập hiện tại',
    "t2":'Vui lòng nhập mật khẩu đăng nhập hiện tại',
    "t3":'Mật khẩu mới',
    "t4":'Vui lòng nhập 6-16 chữ số và chữ cái',
    "t5":'Xác nhận mật khẩu',
    "t6": 'Vui lòng nhập 6-16 chữ số và chữ cái',
    "t7":'Xác nhận',
    "t8":'Mật khẩu không phù hợp với mật khẩu xác nhận'
  },
  "sztxmm":{//Đặt mật khẩu rút tiền
    "title":'Thay đổi mật khẩu giao dịch',
    "wjtkmm": 'Quên mật khẩu giao dịch',
    "qsrjdlmm":'Vui lòng nhập mật khẩu giao dịch hiện tại',
    "zh": 'Tài khoản',
    "qsryxhzsj": 'Vui lòng nhập địa chỉ email hoặc số điện thoại di động của bạn',
    "t1":'Mật khẩu giao dịch hiện tại',
    "t2":'Mật khẩu giao dịch mới',
    "t3":'Vui lòng nhập mật khẩu giao dịch gồm 6 chữ số',
    "t4":'Xác nhận mật khẩu',
    "t5":'Quên mật khẩu giao dịch? ',
    "t6":'Xác nhận',
    "t7": 'Mật khẩu không phù hợp với mật khẩu xác nhận',
    "t8":'Mật khẩu giao dịch',
    "yzm": 'Mã xác minh',
    "qsryzm": 'Vui lòng nhập mã xác minh',
    "hqyzm": 'Nhận mã xác minh'
  },
  "record": {
    "cbjl": 'Bản ghi tiền gửi xu',
    "tbjl": 'Hồ sơ rút tiền',
    "status":"['Chưa xem xét', 'Đã thông qua', 'Đã từ chối']",
    "bhly": 'Lý do từ chối',
    "ldz": 'Địa chỉ:',
    "cjsj": 'Thời gian tạo:',
    "zzsj": 'Thời gian chuyển nhượng:',
    "czl": 'Chuỗi nạp tiền:',
    "zrl": 'Chuỗi truyền:',
    "jyhx": 'Băm giao dịch:'
  },
  "yqm": {
    "wdyqlj": 'Liên kết thư mời của tôi',
    "wdyqm": 'Mã thư mời của tôi',
    "schbyq": 'Tạo lời mời áp phích',
    "bctp": 'Lưu ảnh',
    "qx": 'Hủy',
    "fx": 'Chia sẻ',
    "yqm": 'Sao chép mã thư mời',
    "bcewmdxc": 'Lưu mã QR vào album ảnh',
    "bcbd": 'Lưu cục bộ'
  },
  "wdtd": {
    "title": 'Nhóm của tôi',
    "td": 'Đội',
    "yqhy": 'Mời bạn bè',
    "ren": 'người',
    "wdtdzrs": 'Tổng số thành viên trong nhóm của tôi',
    "uid": 'UID:',
    "zh": 'Tài khoản:',
    "tdrs": 'Quy mô nhóm:',
    "zcsj": 'Ngày đăng ký:'
  },
  "wdyj": {
    "title": 'Hiệu suất của tôi',
    "wdyd": 'Thế hệ của tôi',
    "dyj": 'Hiệu suất',
    "tdzyj": 'Thành tích chung của đội',
    "uid": 'UID:',
    "tdrs": 'Quy mô nhóm:',
    "yj": 'Hiệu suất:'
  },
  "zc": {
    "title": 'Tài sản',
    "zzczh": 'tổng tài sản tương đương',
    "dh": 'Trao đổi',
    "yczc": 'Nội dung ẩn dưới dạng 0',
    "xj": 'giá hiện tại',
    "zh": 'Đã chuyển đổi',
    "zcmx": 'Chi tiết nội dung',
  },
  "duihuang": {
    "title": 'Trao đổi',
    "hl": 'Tỷ giá hối đoái',
    "zf": 'Thanh toán',
    "qbdh": 'Trao đổi tất cả',
    "ky": 'Có sẵn',
    "dd": 'Nhận',
    "ljdh": 'Đổi ngay',
    "cont": 'Tỷ giá hối đoái thay đổi, tùy thuộc vào số tiền thực tế nhận được',
    "yebz": 'Số dư không đủ',
    "ksslbz": 'Không đủ số lượng',
    "qtxje": 'Vui lòng nhập số lượng',
    "dhcg": 'Trao đổi thành công',
    "mrcg": 'Mua thành công',
    "mccg": 'bán thành công',
    "wtcg": 'Ủy quyền thành công',
    "ts": 'Nhắc',
    "btcmTips": 'Theo cài đặt hợp đồng thông minh, GDCC trao đổi USDT sẽ bắt đầu vào ngày 8 tháng 8 năm 2023. ',
    "qx": 'Hủy'
  },
  "sign": {
    "title": 'Đăng nhập để nhận xu',
    "title2": 'Phần thưởng đăng nhập hàng ngày',
    "title3": 'Phần thưởng đăng nhập',
    "qd": 'Đăng nhập',
    "yqd": 'Đăng nhập',
    "hdgz": 'Quy tắc sự kiện',
    "qdjl": 'Hồ sơ đăng ký',
    "qdcg": 'Đăng nhập thành công'
  },
  "langNew": {
    "wd": "Của tôi",
    "jd": "Mượn",
    "jghy": "Tương lai",
    "xbsg": "Mua tiền Singapore",
    "sylx": "Loại phúc lợi",
    "syts": "Số ngày kiếm được: ",
    "rsy": "Thu nhập hàng ngày: ",
    "rsy2": "Thu nhập hàng ngày",
    "yjdts": "Số ngày mượn: ",
    "jdsy": "Thu nhập cho vay: ",
    "jdsy2": "Thu nhập cho vay",
    "jdrq": "Ngày mượn: ",
    "qdsy": "Lợi ích khi đăng nhập",
    "tgsy": "Quyền lợi Khuyến mãi",
    "sybl": "Tỷ lệ lợi nhuận",
    "sybl2": "Tỷ lệ lợi nhuận: ",
    "ljcy": "Tham gia ngay",
    "zsy": "Tổng thu nhập",
    "jdrz": "Nút liên kết",
    "jiedian": "nút",
    "qsrje": "Xin vui lòng nhập một nút",
    "xyb": "Tiếp theo",
    "zhye": "Số dư tài khoản",
    "dzye": "Số dư địa chỉ",
    "zhyezh": "Số dư tài khoản (tương đương)",
    "zq": "Dấu chấm: ",
    "zq2": "dấu chấm",
    "jdsl": "Số tiền cho vay",
    "yxbd": "Xác minh email",
    "qsryxzh": "Vui lòng nhập tài khoản email của bạn",
    "yxgz": "Địa chỉ email đã nhập không tuân thủ quy tắc",
    "jxz": "Đang tiến hành",
    "ywc": "Đã hoàn thành",
    "day": "ngày",
    "jg": "Giá: ",
    "zwsj": "Không có dữ liệu~",
    "wyjb": "Mượn",
    "fxjl": "Chia sẻ phần thưởng",
    "aqsz": "Cài đặt bảo mật",
    "wded": "Thế hệ thứ hai của tôi",
    "wdsd": "Ba thế hệ của tôi",
    "dbxe": "Giới hạn giao dịch một lần",
    "tjdd": "Gửi đơn hàng",
    "tqsh": "Rút tiền quy đổi:  ",
    "shuhui": "Sự chuộc lỗi",
    "ljdz": "Địa chỉ liên kết",
    "yyqh": "Chuyển đổi ngôn ngữ",
    "zxkf": "Dịch vụ khách hàng",
    "syl": "Trả hàng ngày",
    "zhuanbi": "Kiếm xu",
    "zbsy": "Kiếm thu nhập bằng tiền tệ",
    "mc": "Tên",
    "zxj": "Giá mới nhất",
    "zfb": "Danh sách tăng",
    "shouye": "Trang chủ",
    "gg": "Thông báo",
    "rzz": "Chứng nhận",
    "yrz": "Đã xác thực",
    "rzsb": "Xác thực không thành công, vui lòng xác thực lại",
    "cxrz": "Xác thực lại",
    "jymmts": "Vui lòng vào cài đặt bảo mật để đặt mật khẩu giao dịch"
  },
  "xbsg":{
    "title": "Tiền xu mới",
    "wdsg": "Thông tin chi tiết",
    "scts": "Ngày nhốt: ",
    "sy": "còn lại",
    "ljsg": "Theo dõi ngay",
    "ysk": "Bán hết",
    "xzjdy": "Theo dõi ngay",
    "dy": "Đặt mua",
    "fxjg": "giá phát hành",
    "fxl": "Vòng tuần hoàn",
    "ssrq": "Ngày niêm yết",
    "yxqx": "Thời gian hiệu lực",
    "qsrsl": "Vui lòng nhập số tiền",
    "syl": "còn lại",
    "sgrq": "đặt mua",
    "sgsl": "Số lượng",
    "bz": "Đồng tiền",
    "yebz": "Số dư USDT không đủ",
    "tgsl": "Vượt qua Qty",
    "shz": "đang xem xét",
    "wtg": "Không vượt qua",
    "ytg": "thông qua"
  },
  "wydb":{
    "title": "Vay",
    "db": "Vay",
    "dbz": "Vay",
    "jl": "ghi lại",
    "jdzq": "vay (ngày)",
    "qhk": "Trả lại",
    "ljdb": "Tích lũy",
    "dhkbs" :"Trong khi chờ thanh toán",
    "jkje": "số tiền",
    "qsrje": "Vui lòng nhập số tiền",
    "rll": "Lãi suất hàng ngày",
    "hkfs": "Trả nợ",
    "dqych": "Hết hạn",
    "lx": "Quan tâm",
    "fkjg": "Người cho vay",
    "tpsc": "Khoản vay tín dụng (tải lên hình ảnh)",
    "fwxx": "Thông tin nhà ở",
    "srzm": "Chứng minh thu nhập (mối quan hệ việc làm)",
    "yhmx": "Sao kê ngân hàng",
    "zjz": "Ảnh ID",
    "yd": "Tôi đã đọc và đồng ý",
    "xy": "Đăng ký hợp đồng vay",
    "sqdb": "đăng ký chuỗi cho vay",
    "gb": "Khép kín",
    "qd": "VÂNG",
    "ts": "Vui lòng kiểm tra Đăng ký hợp đồng vay",
    "dbjl": "ghi lại",
    "hkhth": "Mã đặt hàng",
    "wsh": "Chưa được đánh giá",
    "yfk": "Tiền vay",
    "sqrq": "thời gian nộp đơn",
    "zq": "xe đạp",
    "dbsl": "số lượng",
    "zhke": "Tổng tiền thanh toán",
    "yhkxq": "Chi tiết trả nợ",
    "bqyhk": "Phải trả trong kỳ hiện tại(USDT)",
    "hktips": "Hãy đảm bảo số dư còn đủ, nếu số dư không đủ vui lòng nạp tiền trước rồi hoàn trả",
    "bj": "Hiệu trưởng",
    "jie": "Vay",
    "ljhk": "Trả nợ ngay lập tức",
    "qcz": "Gửi tiền",
    "yebzqxcz": "Không đủ số dư, vui lòng nạp tiền trước và sau đó hoàn trả",
    "znj": "phí thanh toán chậm",
    "yqts": "Ngày quá hạn"
  },
  "hkxq":{
    "dd":"Gọi món",
    "fzhkdz":"Sao chép địa chỉ trả nợ",
    "hkxq": "Chi tiết trả nợ",
    "zlx": "tổng lãi",
    "zhk": "tổng số tiền hoàn trả",
    "hkjg": "cơ quan trả nợ",
    "qschkpz": "Vui lòng tải lên chứng chỉ hoàn trả",
    "hkpz": "giấy chứng nhận trả nợ"
  },
  "kxt": {
    "gao":"H",
    "di":"L",
    "wtgd": "Lệnh đang chờ",
    "cj": "Thỏa thuận",
    "jj": "Thông tin",
    "sj": "Thời gian",
    "fx": "Xu hướng",
    "jg": "Giá",
    "sl": "Số lượng",
    "mr": "Mua",
    "mc": "Bán",
    "mp": "Đấu thầu",
    "sp": "Đang bán",
    "slb": "Số lượng",
    "fhsj": "Thời gian công bố",
    "fhsl": "Mã số phát hành",
    "bps": "Sách trắng",
    "gw": "Trang web chính thức",
    "yue": "Tháng",
    "ft": "Ảnh phụ",
    "zt": "Ảnh chính",
    "sdt": "Độ sâu",
    "zx": "Tùy chọn",
    "djck": "Bấm để xem"
  },
  "jghy": {
    "jghy": "Tương lai",
    "yxhy": "Hợp đồng vĩnh viễn",
    "mz": "Mua dài hạn",
    "md": "Bán ngắn hạn",
    "gmj": "Giá mua",
    "jsj": "Giá thanh toán",
    "xj": "Giá hiện thời",
    "fx": "Xu hướng",
    "sl": "Số lượng",
    "jgsj": "Thời gian giao",
    "gb": "Đóng",
    "jxxd": "Tiếp tục đặt lệnh",
    "cclb": "Danh sách lệnh",
    "zc": "Hiện thời",
    "lscc": "Lịch sử",
    "qblx": "Tất cả các loại",
    "yk": "Lãi và lỗ",
    "ddqr": "Xác nhận lệnh",
    "dqsj": "Thời gian hết hạn",
    "jssj": "Thời gian giao",
    "sy": "Lãi",
    "tzje": "Mức giá đầu tư",
    "zdje": "Giá thấp nhất 0",
    "kyye": "Thăng bằng",
    "kyye2": "Thăng bằng: ",
    "sxf": "Phí: ",
    "sxfl": "Phí",
    "jypz": "Tên",
    "jyfx": "Xu hướng",
    "qrxd": "Xác nhận",
    "dqye": "Số dư hiện thời"
  },
  "zhjl": {
    "title": "Lịch sử nội dung",
    "cbtb": "Ký quỹ & Rút tiền",
    "jymx": "Lịch sử giao dịch",
    "tgyj": "Hoa hồng khuyến mại",
    "wwc": "Hoàn tác",
    "ywc": "Đã hoàn tất"
  },
  "tipsNew":{
    "wjmmts": "Khôi phục mật khẩu bằng mã xác minh",
    "qscpztp": "Tải lên hình ảnh phiếu thưởng",
    "emailgsts": "Vui lòng nhập email hợp lệ",
    "telgsts": "Số điện thoại di động không chính xác",
    "lcmmbyz": "Vui lòng xác nhận mật khẩu của bạn",
    "zdsl": "Tối thiểu ",
    "sldydy": "Số lượng lớn hơn hoặc bằng",
    "zxtzsl": "Tối thiểu ",
    "ddz": "Đang chờ đợi",
    "xs": "Giờ",
    "min": "Số tiền tối thiểu ",
    "max": "Số tiền tối đa ",
    "yebz": "Thiếu cân bằng",
    "qsrss": "Vui lòng nhập lô",
    "zdss": "Số lô tối thiểu",
    "yjj": "từ chối",
    "shz": "chuộc lỗi",
    "zwkfcz": "Đơn vị tiền tệ này chưa mở để nạp tiền",
    "jiaoge": "Giao hàng",
    "zhang": "tăng",
    "die": "rơi",
  },
  "assets": {
    "total": "Chuyển đổi tài sản",
    "avaiable": "có sẵn",
    "conversion": "Chuyển đổi",
    "canuse": "có sẵn",
    "yczc":"Nội dung ẩn bằng 0"
  },
  "status": {
    "statusText": ['failure','waiting','success'],
  },
  "langNew2":{
    "zczgz": "Tổng tài sản",
    "hgx": "Tuân thủ",
    "yszc": "Chính sách bảo mật",
    "gywm": "Giới thiệu về chúng tôi",
    "zb": "Định lượng AI",
    "mnjy": "Giao dịch Mô phỏng",
    "xbzq": "Khu vực tiền tệ Singapore",
    "flzq": "Trung tâm phần thưởng",
    "cjmnzhcg": "Tạo tài khoản demo thành công!",
    "wdzh": "Tài khoản của tôi",
    "yymnzhts": "Đã có tài khoản ảo, vui lòng không đăng ký lại",
    "tcmnzh": "Thoát khỏi tài khoản demo",
    "mnzhgz": "Định giá tài khoản demo",
    "mnzh": "Tài khoản Demo",
    "ljdzsb": "Không thể kết nối với địa chỉ",
    "ysq": "Được ủy quyền"
  },
  "c2c":{
    "bt": "P2P",
     "bt2": "Dịch vụ thanh toán P2P",
     "cjdd": "Tạo đơn hàng",
     "mblc": "Tiền gửi tiền pháp định",
     "cjydd": "Tạo đơn đặt hàng trước",
     "xmjfk": "Thanh toán cho người bán",
     "tqhb": "Rút tiền kỹ thuật số của bạn",
     "ddzt": "Trạng thái đơn hàng",
     "wdys": "Lợi thế của chúng tôi",
     "c1": "Giao dịch ở mức giá bạn muốn",
     "c2": "Tự do mua và bán tiền điện tử với mức giá ưa thích của bạn. Mua và bán từ các ưu đãi hiện có hoặc tạo quảng cáo giao dịch để đặt mức giá lý tưởng của bạn.",
     "c3": "Phí giao dịch thấp",
     "c4": "Giao dịch ngang hàng (P2P) cho phép người bán tự do xác định phương thức thanh toán họ muốn một cách minh bạch, mua và bán tiền điện tử thông qua hơn 700 phương thức thanh toán bao gồm chuyển khoản ngân hàng và tiền mặt.",
     "c5": "Nhiều phương thức thanh toán",
     "c6": "Giao dịch ngang hàng (P2P) cho phép người bán tự do xác định phương thức thanh toán họ muốn. Mua và bán tiền điện tử với hơn 700 phương thức thanh toán, bao gồm chuyển khoản ngân hàng, tiền mặt.",
     "wpp": "Không khớp",
     "ypp": "Đã khớp",
     "ysx": "Đã hết hạn",
     "ddh": "Mã đơn hàng",
     "mrje": "Mua số lượng",
     "mrbz": "Mua tiền tệ",
     "nssdgj": "Đất nước",
     "qsrnssdgj": "Xin vui lòng nhập quốc gia",
     "fkrxm": "Tên người thanh toán",
     "qsrfkrxm": "Vui lòng nhập tên người thanh toán",
     "yx": "Email",
     "qsryx": "Vui lòng nhập địa chỉ email của bạn",
     "mmbz": "Loại mua hàng",
     "qxzmmbz": "Vui lòng chọn loại hình mua hàng",
     "qxz": "Hãy chọn",
     "fkfs": "Phương thức thanh toán",
     "qtxfkfs": "Vui lòng điền phương thức thanh toán",
     "zh": "Tài khoản",
     "fb": "Loại tiền thanh toán",
     "qtxfb": "Vui lòng điền loại tiền tệ thanh toán",
     "ngmdje": "Số tiền bạn mua",
     "qsrje": "Vui lòng nhập số tiền",
     "wxts": "Lời nhắc nồng nhiệt:",
     "dsh": "Đang được xem xét",
     "ygq": "Đã hết hạn",
     "jcwdwt": "Giới thiệu về P2P",
     "tjpz": "Gửi chứng từ",
     "ckje": "Số tiền phù hợp",
     "qsrckje": "Vui lòng nhập số tiền phù hợp",
     "tjzzfb": "Chuyển bản sao",
     "tjjzzm": "Chứng minh thư (mặt trước)",
     "tjjzfm": "Chứng minh thư (mặt sau)",
     "psts1": "Chú ý những điểm sau khi chụp",
     "psts2": "Xin lưu ý rằng đường viền của hình ảnh đã hoàn chỉnh, phông chữ rõ ràng và độ sáng đồng đều",
     "psts3": "Vui lòng không tải lên ảnh ID không khớp với tên của bạn",
     "qsczzfb": "Vui lòng tải lên bản sao chuyển khoản",
     "qscjzzm": "Vui lòng tải lên mặt trước bằng lái xe của bạn",
     "qscjzfm": "Vui lòng tải lên mặt sau giấy phép lái xe của bạn",
     "tj": "Gửi",
     "je": "Phạm vi giới hạn",
     "ljtg": "Đặt hàng",
     "sp": "Hiểu DeFi",
     "xq": "Chi tiết",
     "lxkfppdd": "Liên hệ với bộ phận dịch vụ khách hàng để đặt hàng",
     "szgj": "Quốc gia",
     "qsrszgj": "Xin vui lòng nhập quốc gia của bạn",
     "fkyhmc": "Tên ngân hàng thanh toán",
     "qsrfkyhmc": "Vui lòng nhập tên ngân hàng thanh toán",
     "dianhui": "Chuyển khoản/Chuyển khoản quốc tế",
     "ccsr": "Nhập vào đây"
  },
  "xyf":{
    "title": "Điểm tín dụng",
    "pgsj": "Thời gian đánh giá"
  },
  "bbjy": {
    "mr": "Mua",
    "mc": "Bán",
    "mai": "Mua",
    "sell": "Bán",
    "xj": "Giới hạn",
    "sj": "Giá thị trường",
    "pk": "Điều bất lợi",
    "jg": "Giá",
    "sl": "Số lượng",
    "mrl": "Khối lượng mua",
    "ss": "Số lượng",
    "mcl": "Khối lượng bán",
    "ky": "Khả dụng",
    "km": "Khả dụng",
    "ksell": "Có thể mua bán",
    "jye": "Giao dịch",
    "dqwt": "Lệnh mở",
    "lswt": "Hoa hồng lịch sử",
    "jj": "Thông tin",
    "wtzl": "Toàn bộ",
    "wtjg": "Giá hoa hồng",
    "ycjl": "Khối lượng giao dịch hoàn tất",
    "cjjj": "Mức giá giao dịch trung bình",
    "cd": "Rút tiền",
    "xd": "Đặt một lệnh",
    "ywc": "Đã hoàn tất",
    "ycd": "Đã rút",
    "wqcj": "Giao dịch hoàn tất",
    "zx": "Tùy chọn",
    "scjg": "Giá thị trường",
    "fhsj": "Thời gian công bố",
    "fhsl": "Mã số phát hành",
    "bps": "Sách trắng",
    "gw": "Trang web chính thức",
    "qx": "Hủy",
    "bbjy": "Trao đổi"
  },
  "hyjy": {
    "mai": "Mua",
    "sell": "Bán",
    "kc": "Vị thế mở",
    "pc": "Đóng",
    "cc": "Vị thế",
    "kp": "Đóng",
    "kpc": "Đóng vị thế ngắn hạn",
    "kcc": "Vị thế",
    "kkd": "Mở vị thế dài hạn",
    "kpd": "Đóng vị thế dài hạn",
    "kkk": "Mở vị thế ngắn hạn",
    "xj": "Giới hạn",
    "sj": "Giá thị trường",
    "xjwt": "Lệnh giới hạn",
    "sjwt": "Giá thị trường",
    "pk": "Điều bất lợi",
    "jg": "Giá",
    "sl": "Số lượng",
    "gg": "Đòn bẩy",
    "tzgg": "Điều chỉnh đòn bẩy",
    "ggbs": "Đòn bẩy",
    "mrl": "Khối lượng mua",
    "ky": "Khả dụng",
    "jye": "Giao dịch",
    "dqwt": "Lệnh mở",
    "lswt": "Hoa hồng lịch sử",
    "ptwt": "Hoa hồng thông thường",
    "dqwtmr": "Lệnh hiện thời (Mua)",
    "dqwtmc": "Lệnh hiện thời (Bán)    ",
    "hywt": "Hoa hồng theo hợp đồng",
    "jj": "Thông tin",
    "wtzl": "Toàn bộ",
    "wtjg": "Giá hoa hồng",
    "ycjl": "Khối lượng giao dịch hoàn tất",
    "cjjj": "Mức giá giao dịch trung bình",
    "cd": "Rút tiền",
    "xd": "Đặt một lệnh",
    "wqcj": "Giao dịch hoàn tất",
    "ywc": "Đã hoàn tất",
    "ycd": "Đã rút",
    "zx": "Tùy chọn",
    "scjg": "Giá thị trường",
    "fhsj": "Thời gian công bố",
    "fhsl": "Mã số phát hành",
    "bps": "Sách trắng",
    "gw": "Trang web chính thức",
    "mrzd": "Mua dài hạn",
    "mrpk": "Mua ngắn hạn ",
    "mczk": "Bán ngắn hạn ",
    "mcpd": "Bán dài hạn",
    "mrkdkz": "Mua khi mở (tăng giá)",
    "mrpkkz": "Mua khi đóng (tăng giá)",
    "mckkkd": "Bán khi mở (giảm giá)",
    "mcpdkd": "Bán khi đóng (giảm giá)",
    "yxhy": "Hợp đồng vĩnh viễn",
    "dc": "Vị thế dài hạn",
    "syl": "Lợi suất",
    "bzjl": "Tỷ lệ ký quỹ",
    "tzbzj": "Điều chỉnh ký quỹ",
    "zyzs": "Chốt lãi & cắt lỗ",
    "zhang": "Số lượng",
    "qblx": "Tất cả các loại",
    "qb": "Tất cả các",
    "ccjg": "Mức giá vị thế",
    "ccsl": "Số lượng vị thế",
    "yk": "Lãi và lỗ",
    "ccsj": "Thời gian của vị thế",
    "zy": "Chốt lãi",
    "zs": "Cắt lỗ",
    "zje": "Tổng tiền",
    "kcs": "Số lượng vị thế mở",
    "kcjg": "Mức giá vị thế mở",
    "ss": "Lô",
    "hand": "1 lô =",
    "qx": "Hủy",
    "qr": "Xác nhận",
    "qbcd":"Hủy tất cả các đơn đặt hàng"
  },
  "bbjyNew":{
    "jylx": "Các loại",
    "jyze": "Số lượng"
  },
  "langNew3":{
    "bzxq": "Chi tiết về các viên gạch di chuyển",
     "znbz": "Di chuyển gạch thông minh định lượng AI",
     "apits": "Kết nối liền mạch với API của hơn 200 sàn giao dịch trên toàn thế giới",
     "jr": "Tham gia",
     "gn": "Chức năng",
     "lhjs": "Giới thiệu về định lượng cổ tức",
     "jqrts": "Robot hoạt động như thế nào?",
     "sctj": "Thống kê thị trường",
     "scqk": "Điều kiện thị trường",
     "jiaoge": "Giao hàng",
     "zhang": "Đứng lên",
     "die": "Ngã",
     "sz": "Cài đặt",
     "qbcp": "Tất cả sản phẩm",
     "jrlh": "Tham gia định lượng AI",
      "sywd": "0 rủi ro, lợi nhuận ổn định",
      "bzbz": "Loại tiền điện tử"
  },
  "sztkmm": {
    "title": "Đặt mật khẩu rút tiền",
    "dlmm": "Mật khẩu đăng nhập ",
    "dlmmts": "Vui lòng nhập mật khẩu đăng nhập",
    "xmm": "Mật khẩu mới",
    "mmts": "Mật khẩu gồm 6 chữ số",
    "qrmm": "Xác nhận mật khẩu",
    "qr": "Xác nhận",
    "qd": "OK",
    "sztkts": "Mẹo: Vui lòng truy cập Trung tâm Bảo mật để đặt mật khẩu giao dịch"
  },
  "bzhl": {
    "title":"Cổ tức",
    "gz": "Quy tắc",
    "tgdd": "Lệnh ký quỹ",
    "zztgdzj": "Tiền được lưu giữ",
    "yjjrsy": "Ước tính hàng ngày",
    "ljsy": "Tổng thu nhập",
    "tgzdd":"Lệnh tạm giữ",
    "cljxcp": "Sản phẩm chiến dịch chiến lược",
    "dbxe":"Giới hạn",
    "rsyl":"Tỷ lệ lợi nhuận hàng ngày",
    "zq":"Chu kỳ đặt hàng",
    "qmr":"Đi và mua",
    "bbzhzc": "Tài sản tài khoản",
    "zcc": "Tổng tài sản(USDT)",
    "dd":"Đơn đặt hàng",
    "buy":"Mua vào",
    "jxcp":"Sản phẩm nổi bật",
    "ckdd":"Kiểm tra đơn hàng",
    "gd":"thêm",
    "xzbzts": "Đơn giản và an toàn. Cổ tức có thể được chọn bằng nhiều loại tiền tệ",
    "qtbz": "Các đồng tiền khác",
    "dj": "Cấp độ",
    "cjwt": "Các vấn đề thường gặp",
    "ddsl": "Số lượng đặt hàng",
    "sl": "Số tiền"
  },
  "bzhlgm": {
    "qtzq": "Chu kỳ 7 ngày USDT",
    "rsyl": "Lợi suất hàng ngày",
    "lczq": "Chu kỳ tài chính",
    "dbxe": "Hạn mức đơn ",
    "pxsj": "Thời gian thanh toán cổ tức",
    "mr": "Hàng ngày",
    "dqfh": "Hoàn trả khi đến hạn",
    "tgzj": "Vốn chủ sở hữu giám hộ",
    "tqsh": "Đổi sớm",
    "yjsy": "Thu nhập dự kiến (USDT)",
    "kyzc": "Tài sản khả dụng(USDT)",
    "cpjs": "Về sản phẩm của chúng tôi",
    "tgje": "Số tiền giám hộ",
    "qsrtgje": "Vui lòng nhập số tiền giám hộ",
    "qb": "Tất cả các",
    "rm": "Bấm vào đây",
    "cpzq": "Chu kỳ sản phẩm",
    "gz": "Hiểu rõ quy định và lợi ích"
  },
  "bzhlwdtg": {
    "title": "Trạng thái đơn hàng",
    "tgz": "Đang bị giam giữ",
    "ywc": "Đã hoàn thành",
    "ysh": "Đã chuộc",
    "tgje": "Số tiền tạm giữ/Thời gian tạm giữ",
    "rsyl": "Chuột quay trở lại hàng ngày",
    "yhl": "Có lợi",
    "xdsj": "Thời gian đặt hàng",
    "sh": "Cứu chuộc",
    "ddxq": "Chi tiết đơn hàng",
    "ddh": "Số đơn hàng.",
    "syts": "Còn lại",
    "ddztxq": "Chi tiết trạng thái đơn hàng"
  },
  "langNew4":{
    "kp": "Khai mạc",
    "zuoshou": "nhận được ngày hôm qua",
    "zg": "cao nhất",
    "zd": "thấp nhất",
    "dqjg": "Giá hiện tại",
    "pcjg": "Giá đóng cửa",
    "gd": "danh sách hàng chờ",
    "gdj": "Giá đặt hàng đang chờ xử lý",
    "gdjg": "Giá đặt hàng đang chờ xử lý",
    "xfbzj": "Yêu cầu đặt cọc bảo đảm: ",
    "ksrfw": "Phạm vi đầu vào khả dụng: ",
    "shou": "Rất nhiều",
    "fdjyk": "lãi và lỗ ròng thả nổi",
    "pcsl": "Đóng số lượng",
    "cx": "thu hồi",
    "qrpc": "Xác nhận đóng vị thế",
    "sx": "lọc",
    "cz": "cài lại",
    "zdl": "biết",
    "kccg": "Đã mở thành công một vị thế!",
    "xzfx": "chọn hướng",
    "lx": "kiểu",
    "xgcc": "sửa đổi vị trí",
    "szzyzs": "Đặt dừng lợi nhuận và dừng lỗ",
    "szhb": "tiền điện tử",
    "gjs": "Kim loại",
    "yy": "thô",
    "jy": "Buôn bán",
    "gp": "Cổ phần",
    "jmhb": "tiền điện tử",
    "gdsj": "Thời gian đặt hàng đang chờ xử lý",
    "gdsl": "Số lượng đặt hàng đang chờ xử lý",
    "fs": "time"
   },
   "deals": {
    "issue_time": "Thời gian công bố",
    "issue_number": "Mã số phát hành",
    "white_book": "Sách trắng",
    "weburl": "Trang web chính thức",
    "video_url": "Video",
    "introduction": "Thông tin",
    "onhand": "1 lô =",
    "position": "Vị thế",
    "leverorder": "Lệnh đòn bẩy",
    "leverposition": "Vị thế đòn bẩy",
    "inputprice": "Nhập giá",
    "inputmul": "Nhập hệ số",
    "selectmul": "Chọn hệ số",
    "onehand": "1 lô =",
    "hand": "Lô giao dịch",
    "marketval": "Giá trị thị trường",
    "bond": "Trái phiếu",
    "balance": "Số dư",
    "type": "Loại",
    "risk": "Tỷ lệ rủi ro",
    "total": "Lợi nhuận tổng",
    "onekey": "Thanh khoản một lần nhấp chuột",
    "makemore": "(Dài hạn)",
    "makeless": "(Ngắn hạn)",
    "current": "Lệnh mở",
    "all": "Tất cả các",
    "weing": "Hoa hồng",
    "tding": "Đang giao dịch",
    "ping": "Đang đóng",
    "pied": "Đã đóng",
    "ceiled": "Đã rút",
    "weprice": "Giá hoa hồng",
    "oprice": "Giá mở cửa",
    "nowprice": "Giá hiện thời",
    "zyprice": "Giá chốt lãi",
    "zsprice": "Giá cắt lỗ",
    "canbond": "Ký quỹ khả dụng",
    "optime": "Thời gian mở cửa",
    "pgtime": "Thời gian đóng cửa",
    "znum": "Số tiền đã chuyển đổi",
    "gprice": "Phí giao dịch qua đêm",
    "pcang": "Đóng",
    "revoke": "Rút tiền",
    "fee": "Phí",
    "you": "Giá thị trường tối ưu"
  },
  "zyzs": {
    "title": "Chốt lãi & cắt lỗ",
    "zy": "Chốt lãi",
    "zs": "Cắt lỗ",
    "qsrzyjg": "Vui lòng nhập giá chốt lãi",
    "qsrzsjg": "Vui lòng nhập giá cắt lỗ",
    "scjg": "Giá thị trường",
    "wxts": "Lời nhắc:",
    "qr": "Xác nhận"
  },
  "ssbt":{
    "ssbt":"Trợ cấp thuế",
    "ssnhm":"Số SSN",
    "qsrssnhm":"Vui lòng nhập số SSN của bạn",
    "idzmz":"Ảnh mặt trước CMND",
    "qscidzmz":"Vui lòng tải lên ảnh mặt trước CMND của bạn",
    "dhfb":"Bản sao chuyển khoản",
    "qscdhfb":"Vui lòng tải lên một bản sao chuyển khoản của bạn",
    "srlyfb":"Bản sao nguồn thu nhập",
    "qscsrlyfb":"Vui lòng tải lên một bản sao nguồn thu nhập của bạn",
  },
  "newReg":{
    "sjh": "điện thoại di động",
    "yx": "e-mail",
    "yqm": "Mã mời",
    "yqm2": "Mã lời mời (tùy chọn)",
    "cjzh": "Tạo tài khoản",
    "sysjhzyx": "Đăng ký bằng số điện thoại di động / email",
    "sj": "Di động",
    "yhxy": "&lt;Thoản thuận người dung&gt;",
    "yhxy2": "Tôi đã đọc và đồng ý với &lt;Thoản thuận người dung&gt;",
    "hmyzh":"Bạn chưa có tài khoản?",
    "qzc":"Đăng ký",
    "qbdl": "Đăng nhập ví",
    "qyqbfw": "Vui lòng sử dụng APP ví để truy cập",
    "dc": "Dăng xuất"
  },
  "langNew5":{
    "dl":"Đăng nhập",
    "ljdz":"Liên kết địa chỉ ví",
    "srdz":"Nhập địa chỉ",
    "ljqq":"Yêu cầu kết nối",
    "qq":"Yêu cầu",
    "qb":"Ví",
    "ckyehhd":"Xem số dư và hoạt động của bạn",
    "qqjypz":"Yêu cầu phê duyệt giao dịch",
    "cro":"Cronos",
    "jj":"Từ chối",
    "lj":"Kết nối",
  }
}



// WEBPACK FOOTER //
// ./src/utils/lang/yn.js